import {
  GapEnum,
  Stack,
} from '@delmonicos/shared-design-system-react/src/components/stack/stack';
import { Text } from '@delmonicos/shared-design-system-react/src/components/typography/text/text';
import { formatDate } from '@delmonicos/shared-sdk/libs/cpms/src/clients/utils/formatters/format-date';
import { OcppLogMessageFormatted } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/logger/ocpp-logs-messsages.interface';
import { isOcppLogCallResultMessageHeartbeat } from '@delmonicos/shared-sdk/libs/cpms/src/libs/ocpp/src/logger/ocpp-logs-messsages.utils';
import { useTranslation } from 'react-i18next';

import i18n from '@app/core/locale/i18n';
import { Logger } from '@app/core/logger/logger';
import { DefaultLogComponent } from '@app/feature/charge-point/charge-point-details/tabs/maintenance-tab/log-card/log-list/log-item/default-log.component';

import { LogItemWrapper } from './log-item-wrapper.component';

export const HeartbeatLogComponent = ({
  log,
}: {
  log: OcppLogMessageFormatted;
}): React.JSX.Element => {
  const { t } = useTranslation();

  if (!isOcppLogCallResultMessageHeartbeat(log.message)) {
    Logger.error('Message is not of type OcppLogCallResultMessageHeartbeat', {
      log,
    });
    return <DefaultLogComponent log={log} />;
  }

  return (
    <LogItemWrapper call={log.message}>
      <Stack gap={GapEnum.S}>
        <Text bold>
          {t(
            'delmonicos-shared-sdk.ocpp-api-models-heartbeat-message-request.received-at',
          )}
        </Text>
        {formatDate(
          log.message.result.currentTime,
          i18n,
          'dd/MM/yyyy HH:mm:ss',
        )}
      </Stack>
    </LogItemWrapper>
  );
};
